// EditComment.jsx
import React, { useState } from "react";
import AddComments from "../AddComment/AddComment";
import { CommentsService } from "../../services";

const EditComment = ({ comment, onCancel, onCommentUpdated }) => {
  const [editedText, setEditedText] = useState(comment.content);

  const handleSaveEdit = async (mediaData) => {
    // Get content from mediaData.text (from Quill editor) or fallback to editedText
    const contentToSave = mediaData?.text !== undefined ? mediaData.text : editedText;
    if (!contentToSave.trim()) return;

    try {
      const updateData = {
        content: contentToSave,
        post_id: comment.post_id
      };

      const response = await CommentsService.updateComment(comment.id, updateData);
      
      if (response?.data?.success) {
        onCommentUpdated({
          ...comment,
          content: contentToSave,
          // Keep existing media unchanged
          image_url: comment.image_url,
          gif_url: comment.gif_url,
        });
      }
    } catch (error) {
      console.error("Error updating comment:", error);
    }
  };

  return (
    <div className="edit-comment-wrapper">
      <AddComments
        commentText={editedText}
        addComment={() => {}} // Not used in edit mode
        onChange={(e) => setEditedText(e.target.value)}
        postId={comment.post_id}
        showEditor={true}
        onInputFocus={() => {}}
        onCancel={onCancel}
        isEdit={true}
        initialText={comment.content}
        onSaveEdit={handleSaveEdit}
        disableMediaEditing={true}
      />
    </div>
  );
};

export default EditComment;